import { useEffect, useState } from 'react'

/** Reactive CSS media query. `useMediaQuery('(max-width: 767.98px)')` → boolean. */
export const useMediaQuery = (query) => {
  const get = () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false)
  const [matches, setMatches] = useState(get)

  useEffect(() => {
    if (!window.matchMedia) return undefined
    const mql = window.matchMedia(query)
    const onChange = (e) => setMatches(e.matches)
    setMatches(mql.matches)
    if (mql.addEventListener) mql.addEventListener('change', onChange)
    else mql.addListener(onChange)
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange)
      else mql.removeListener(onChange)
    }
  }, [query])

  return matches
}

// Bootstrap 5 breakpoints
export const MQ = {
  xsOnly: '(max-width: 575.98px)',
  belowMd: '(max-width: 767.98px)',
  belowLg: '(max-width: 991.98px)',
}
